import { importLogic } from "./ImportFile.logic";
import {
  saveListScriptOffset,
  saveCountScriptOffset,
} from "../../ScriptOffsets/Infrastructure/ScriptOffsets.store";

export async function importFile(userId, file) {
  const response = await importLogic(userId, file);
  saveListScriptOffset(response);
  saveCountScriptOffset(response.length);
}
